import styled from 'styled-components';

export const Icon = styled.i`
  margin-right: 20px;
  font-size: 35px;
`;
